import { SerializedEditorState } from '@payloadcms/richtext-lexical/lexical';
import { ReactNode } from 'react';
import CustomRichText from '../CustomRichText';

export interface ProposalCardProps {
  title: ReactNode | SerializedEditorState;
  txtContent1: {
    title: ReactNode | SerializedEditorState;
    subtitle: ReactNode | SerializedEditorState;
  };
  txtContent2: {
    title: ReactNode | SerializedEditorState;
    subtitle: ReactNode | SerializedEditorState;
  };
}
export default function CourseListItem({ title, txtContent1, txtContent2 }: ProposalCardProps) {
  return (
    <div
      data-meta="CourseListItem"
      className="flex gap-12 backdrop-blur-sm bg-white/30 rounded-3xl p-6"
    >
      <div className=" flex flex-col justify-between sm:grid sm:grid-cols-12 text-white">
        <CustomRichText
          data={title}
          tag="div"
          className="text-3xl text-center content-center sm:col-span-4 font-bold mb-6 mr-4"
        />

        <div className="sm:flex flex-col gap-2 lg:grid lg:grid-cols-8  lg:gap-4 col-span-8">
          <div className="col-span-4">
            <CustomRichText
              data={txtContent1.title}
              tag="div"
              className="text-xl font-bold lg:mb-6"
            />
            <CustomRichText data={txtContent1.subtitle} tag="div" className="font-light" />
          </div>
          <div className="col-span-4 max-sm:mt-4">
            <CustomRichText
              data={txtContent2.title}
              tag="div"
              className="text-xl font-bold lg:mb-6"
            />
            <CustomRichText data={txtContent2.subtitle} tag="div" className="font-light" />
          </div>
        </div>
      </div>
    </div>
  );
}
